
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gwgFVuCDIv2cBEr7_fjElm0O1cwawwqDbOL_SHQDHrnwMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index2praJh8VawKSGw0xk6L6gRS1ag5rzOMXi_45ciS3XS7OkMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchF_45_icA89yKovCPYkpwb7Rs0jrmyRNmi5E7VdU1sLF2YMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexy2b8DRTxu0kUtmDm6BiUhLilkuKnXi4pptdydDBUyNwMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93bM_45eOS7LVdfIGcHLOUNGkdMLmVrOqsJHzfnynCAM92QMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index81_nYc3srHhR8A5WTo19UyhS3GFzMka90upguOJEFwkMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93por2k5W_45OjOeh3nC8nI5ijY49uake_JdH66KCqDqlekMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexWpiTBsw4X1MCegUMIJqkcNEyUrSdJj2UTVysBMFc0nUMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93jYR_4O1Ai2HkybhZDzbnW7eTZqDP2w1NycxTwcpsFTEMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexa4RVQkqJsf16HtzDoMLHV54wFN924lpkCfRqRVo17i0Meta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexyOk4zJXxgtG2VgKpe_0uy_VdvbXv8b1tJ5ssctSQqzEMeta } from "/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index81_nYc3srHhR8A5WTo19UyhS3GFzMka90upguOJEFwkMeta || {},
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexWpiTBsw4X1MCegUMIJqkcNEyUrSdJj2UTVysBMFc0nUMeta || {},
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexa4RVQkqJsf16HtzDoMLHV54wFN924lpkCfRqRVo17i0Meta || {},
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexyOk4zJXxgtG2VgKpe_0uy_VdvbXv8b1tJ5ssctSQqzEMeta || {},
    component: () => import("/codebuild/output/src3119528202/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]